module.exports = __webpack_public_path__ + "eebfdcdc3787c33ae55f84b6953709b2.png";